import { render, staticRenderFns } from "./DigitalResDetail.vue?vue&type=template&id=927e28fc&scoped=true&"
import script from "./DigitalResDetail.vue?vue&type=script&lang=js&"
export * from "./DigitalResDetail.vue?vue&type=script&lang=js&"
import style0 from "./DigitalResDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DigitalResDetail.vue?vue&type=style&index=1&id=927e28fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927e28fc",
  null
  
)

export default component.exports